export function bootComplete(state) {
  state.isBooting = false;
}

export function blockInteraction(state) {
  state.canInteract = false;
}

export function allowInteraction(state) {
  state.canInteract = true;
}

export function updateAccount(state, { account }) {
  state.account = account;
}

export function updateToken(state, { accessToken }) {
  state.accessToken = accessToken;
}
